import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { sessionDeletedEpic } from './sessionDeletedEpic';
import { sessionModifiedEpic } from './sessionModifiedEpic';
import { sessionQuotingEpic } from './sessionQuotingEpic';

export const sessionEpic = () =>
  combineEpics(
    withAppCrashIfException('sessionModifiedEpic', sessionModifiedEpic()), // OK
    withAppCrashIfException('sessionDeletedEpic', sessionDeletedEpic()), // OK
    withAppCrashIfException('sessionQuotingEpic', sessionQuotingEpic()), // OK
  );
